import { createContext, useState, useEffect } from "react";

const GlobalContext = createContext(null);

const GlobalProvider = ({ children }) => {
	const [token, setToken] = useState(null);
	const [authenticated, setAuthenticated] = useState(false);

	// sidebar state
	const [openLeft, setOpenLeft] = useState(localStorage.getItem("openLeft") === "true");
	const [openRight, setOpenRight] = useState(
		localStorage.getItem(`right-${window.location.pathname}`) === "true"
	);

	const handlerSideLeft = (bool) => {
		localStorage.setItem("openLeft", bool);
		setOpenLeft(bool);
	};

	const handlerSideRight = (bool) => {
		localStorage.setItem(`right-${window.location.pathname}`, bool);
		setOpenRight(bool);
	};

	useEffect(() => {
		const urlParams = new URLSearchParams(window.location.search);
		const urlToken = urlParams.get("token");

		if (urlToken) {
			sessionStorage.setItem("auth_token", urlToken);
			setToken(urlToken);
			setAuthenticated(true);
		} else {
			const storedToken = sessionStorage.getItem("auth_token");
			if (storedToken) {
				setToken(storedToken);
				setAuthenticated(true);
			}
		}
	}, []);

	const loginWithToken = (newToken) => {
		sessionStorage.setItem("auth_token", newToken);
		setToken(newToken);
		setAuthenticated(true);
	};

	const logout = () => {
		sessionStorage.removeItem("auth_token");
		setToken(null);
		setAuthenticated(false);
	};

	return (
		<GlobalContext.Provider
			value={{
				token,
				authenticated,
				loginWithToken,
				logout,
				openLeft,
				handlerSideLeft,
				openRight,
				handlerSideRight,
			}}
		>
			{children}
		</GlobalContext.Provider>
	);
};

export { GlobalContext, GlobalProvider };
